import BaseAPI from "../api";

const path: string = "/my-course-of-study";

export class MyCourseOfStudyApi extends BaseAPI {
  static list(query: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static findById(id: any, id_academic_year: any): Promise<any> {
    return this.api.get(`${path}/${id}/term/${id_academic_year}`);
  }
  static getCourseAnnual(id: any, id_course_annual: any): Promise<any> {
    return this.api.get(`${path}/${id}/course_annual/${id_course_annual}`);
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patch(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static download(id: any, term:any): Promise<any> {
    return this.api.get(`${path}/${id}/term/${term}/download`,{
            responseType: "arraybuffer",

    });
  }
  static download_teacher(id: any, term:any): Promise<any> {
    return this.api.get(`${path}/teacher/${id}/term/${term}/download`,{
            responseType: "arraybuffer",

    });
  }
}
